<script lang="ts">
    import type { ITrxWire } from '../../order'
    import Icon from '@iconify/svelte'

    import Date from 'hydria/components/Date.svelte'

    interface Props {
        trx: ITrxWire
    }

    let { trx }: Props = $props()

    let expandTransaction = $state(false)
    let expandQuery = $state(false)
</script>

<h4>Virement bancaire</h4>

<table class="table">
    <caption>Transaction <button type="button" class="btn btn-sm btn-outline-secondary float-end" class:active={expandTransaction} onclick={() => (expandTransaction = !expandTransaction)}><Icon inline icon="fa:arrows-v" /></button></caption>
    <tbody>
        <tr><th>Statut</th><td>{trx.status}</td></tr>
        {#if expandTransaction}
            <tr><th>Méthode</th><td>{trx.payment_method}</td></tr>
            <tr><th>Date</th><td><Date value={trx.stamp} format="h-table" /></td></tr>
            <tr><th>Address IP</th><td>{trx.ip_address}</td></tr>
            <tr><th>ID</th><td>{trx.id}</td></tr>
        {/if}
    </tbody>
</table>

<table class="table">
    <caption>Virement <button type="button" class="btn btn-sm btn-outline-secondary float-end" class:active={expandQuery} onclick={() => (expandQuery = !expandQuery)}><Icon inline icon="fa:arrows-v" /></button></caption>
    <tbody>
        <tr><th>No. de confirmation</th><td>{trx.data.wire.confirmation}</td></tr>
        <tr><th>Date</th><td><Date value={trx.data.wire.date} format="h-table" /></td></tr>
        <tr><th>Commentaire</th><td>{trx.data.wire.comment}</td></tr>
        {#if expandQuery}
            <tr><th>Montant</th><td>{trx.data.wire.amount}</td></tr>
        {/if}
    </tbody>
</table>
